module.exports = __webpack_public_path__ + "static/media/carlton.700f448a.png";